export default __webpack_public_path__ + "0f76abc7ed1959fe0790a81b2d0c8fb9.png";